// extracted by mini-css-extract-plugin
export var accordion = "AccordionSection-module--accordion--1mQV7";